import AOS from 'aos';
import "./modules/nav"
import "./modules/map"

AOS.init({
    once: true,
})

document.addEventListener('DOMContentLoaded', function(){
    const headerBlock = document.querySelector('header');
    setTimeout(function(){
        headerBlock.style.opacity = '1';
   }, 900);
});

window.addEventListener('load', AOS.refresh);